module.exports = __webpack_public_path__ + "media/assets/fonts/registered-symbol-superscript-8a8153398d3e1c82911c46674c56016f.woff";